import { useCallback } from 'react';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack } from '@cbhq/cds-web/layout';
import { Modal, ModalBody, ModalHeader } from '@cbhq/cds-web/overlays';
import { Pressable } from '@cbhq/cds-web/system';
import { TextBody, TextLabel2 } from '@cbhq/cds-web/typography';

import { BaseL3Chain } from ':cloud/types/ts_types';
import { handleDownloadJson } from ':cloud/utils/files';

import { DetailItem } from './DetailItem';

type ConfigModalProps = {
  onClose: () => void;
  isVisible: boolean;
  chain?: BaseL3Chain;
};

export function ConfigModal({ chain, onClose, isVisible }: ConfigModalProps) {
  const handleDownload = useCallback((url?: string) => {
    return () => {
      if (!url) return;
      handleDownloadJson(url);
    };
  }, []);

  return (
    <Modal visible={isVisible} onRequestClose={onClose} width={450}>
      <ModalHeader title="Export network configuration" />
      <ModalBody>
        <VStack spacingVertical={3} gap={5}>
          <TextBody as="p" color="foreground">
            You can export and move your network config to another platform. Your network is yours.
          </TextBody>

          <VStack gap={0.5}>
            <DetailItem
              label="Rollup config"
              value="rollup.json"
              actionElement={
                <Pressable
                  background="transparent"
                  onPress={handleDownload(chain?.resources?.files?.rollupJson)}
                >
                  <Icon name="download" size="s" color="foreground" />
                </Pressable>
              }
            />
            <TextLabel2 as="p" color="foregroundMuted">
              Use rollup config to move your L3 to another platform.
            </TextLabel2>
          </VStack>

          <DetailItem
            label="Genesis"
            value="genesis.json"
            actionElement={
              <Pressable
                background="transparent"
                onPress={handleDownload(chain?.resources?.files?.genesisJson)}
              >
                <Icon name="download" size="s" color="foreground" />
              </Pressable>
            }
          />
        </VStack>
      </ModalBody>
    </Modal>
  );
}
